import { GAME_CONFIG, getHitsUntilLose } from './gameConfig';

export const getLifeFeedback = (elapsed, reserve) => {
  const life = Math.max(0, Math.min(GAME_CONFIG.time.maxBuffer, reserve));
  const errors = Math.max(0, Math.ceil(getHitsUntilLose(elapsed, life)) - 1);
  return {
    percent: Math.round(life / GAME_CONFIG.time.maxBuffer * 100),
    errors,
    danger: errors <= 1,
    label: life <= 0 ? 'Sin vida' : errors === 0 ? 'El próximo fallo te elimina'
      : `${errors} ${errors === 1 ? 'error de margen' : 'errores de margen'}`,
  };
};
